var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{ref:"shippingSheetLink",style:({ display: 'none' }),attrs:{"target":"_blank","href":_vm.shippingSheetPdf}}),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.downloadShippingSheet}},[_vm._v(" Hoja de envío ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }